module.exports = __webpack_public_path__ + "img/lock.b656c3b4.svg";